import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import data from './modules/data'
import misc from './modules/misc'

// Set Vuex usage
Vue.use(Vuex)

export const store = new Vuex.Store({
	modules: {
		auth,
		data,
		misc,
	},
	state: {
		isOnline: true,
	},
	getters: {
		isOnline(state) {
			return state.isOnline
		},
	},
	mutations: {
		setOnlineStatus(state, status) {
			state.isOnline = status
		},
	},
	actions: {
		setupOfflineMode(vuexContext, targetPath) {
			vuexContext.commit('setOnlineStatus', false)
			if (history.pushState) {
				history.pushState(null, 'Connection Error', targetPath)
			}
		},
	},

	// Enable strict mode in development to get a warning when mutating state outside of a mutation
	strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/store/index.js